import { Map } from "immutable";

export const COMPANY_TYPES = new Map({
    Retailer: 3,
    Distributor: 2,
    Anchor: 1
});

export const ORDERING_WAYS = new Map({
    "software": 0,
    "app": 1,
    "on call": 2,
    "via sms": 3,
    "over whatsapp": 4,
    "by your sales manager": 5,
});

export const LEDGER_TYPES = new Map({
    "Approved": 1,
    "In Review": 3,
    "Rejected": 2
});

export const ERP_REQUEST_SOURCE = new Map({
    "Web Portal": 1,
    "Sales App": 2
});

export const ERP_REQUEST_TYPE = new Map({
    "ERP Sync": 1,
    "Ledger Upload": 2
});

export const ERP_REQUEST_CURRENT_STATUS = new Map({
    "Created": 1,
    "Submitted": 2,
    "Cancelled": 3,
    "Under Process": 4,
    "Completed": 5,
    "Rejected": 6,
    "Ledger Parser Under Process": 7
});

export const LEDGER_DATA_SOURCE = new Map({
    "Tally Sync": 1,
    "Mannual" : 2,
    "Other" : 3,
    "Busy" : 5,
});

export const INVOICE_PARSE_JOB_STAGE_LABELS = new Map({
    INITIALIZED: "Initialized",
    PROCESSING: "Processing",
    PROCESSED: "Processed",
    REVIEW_INITIALIZED: "Review Initialized",
    REVIEW_PENDING: "Review Pending",
    REVIEW_CLOSED: "Review Closed",
    PENDING_ADMIN_APPROVAL: "Pending Admin Approval",
    PENDING_FOR_RATE_PER_UNIT: "Pending For Rate Per Unit",
    PENDING_FOR_WCTL: "Pending For WCTL",
    PENDING_FOR_FLEXIBLE_TENOR_AND_ROI: "Pending For Flexible Tenor And Roi",
});
